
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/[uid]",
      function () {
        return require("private-next-pages/shop/[uid].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/[uid]"])
      });
    }
  